import { ref } from "vue"
import type { Store } from 'vuex'

const instance = ref<Store<any>|undefined>(undefined)

export function useVuex() {
    function setVuexInstance(storeInstance: Store<any>) {
        instance.value = storeInstance
    }

    return {
        vuex: instance,
        setVuexInstance,
    }
}